import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  useDisclosure,
  Table,
  TableCaption,
  Thead,
  Tr,
  Tbody,
  Td,
  TableContainer,
  Input,
  Flex,
} from "@chakra-ui/react"
import React from "react"
import { useToast } from "@chakra-ui/react"
import { Th } from "./Th"
import { formatDate } from "../../../../utils/formatDate"
import { useRef } from "react"
import { api } from "../../../../services/api"

export function NotasAntecipadas({ dados, resultado }) {
  console.log("dados: ", dados)

  const { isOpen, onOpen, onClose } = useDisclosure()
  const [loading, setloading] = React.useState(false)
  const cancelRef = React.useRef()
  const toast = useToast()
  const [numeroNota, setNumeroNota] = React.useState("")

  async function updateNota(codprod, numped) {
    if (numeroNota === "") {
      return
    }

    const params = {
      numero_unico: numeroNota,
      codigo_produto: codprod,
      numero_pedido: numped,
    }

    const response = await api.post("/site/v2/pedido/atualiza-pendencia-nota", params)

    console.log("response: ", response)

    console.log("params: ", params)

    setNumeroNota("")
  }

  return (
    <>
      <Text as="h2" onClick={onOpen} fontSize="1.2rem" fontWeight="bold" color="gray.600" cursor={"pointer"}>
        {dados?.length} notas antecipadas
      </Text>
      <Modal
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isOpen={isOpen}
        size={"6xl"}
      >
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>
            {" "}
            <Text as="h2" fontSize="1.2rem" fontWeight="bold" color="gray.600">
              Notas antecipadas
            </Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <TableContainer>
              <Table fontSize="12px">
                <TableCaption>Tabela de informações de notas fiscais pendentes de emissão</TableCaption>
                <Thead>
                  <Tr>
                    <Th label="Nº Ped" />
                    <Th label="Nº Innovation" />
                    <Th label="Limite Produção" />
                    <Th label="Solicitação Nota" />
                    <Th label="Nome do cliente" />
                    <Th label="Nome parc" />
                    <Th label="Valor nota" />
                    <Th label="Nota Finalização" />
                  </Tr>
                </Thead>
                <Tbody>
                  {dados.map((data, idx) => {
                    return (
                      <Tr id="id_tr" key={data.numero_unico}>
                        <Td padding=".3rem" textAlign="center">
                          {data.numero_pedido}
                        </Td>

                        <Td padding=".3rem" textAlign="center">
                          {data.numero_unico_origem}
                        </Td>

                        <Td padding=".3rem" textAlign="center" style={{ position: "relative", width: "160px" }}>
                          {new Date(data.data_saida).toLocaleDateString("pt-BR", {
                            timeZone: "UTC",
                          })}
                        </Td>
                        <Td padding=".3rem" textAlign="center" style={{ position: "relative", width: "160px" }}>
                          {formatDate(data.data_emissao_nota)}
                        </Td>
                        <Td padding=".3rem" textAlign="center" style={{ position: "relative", width: "190px" }}>
                          <Text as="p" noOfLines={1} style={{ textAlign: "left" }}>
                            {data.nome_parc.length > 20 ? data.nome_parc.slice(0, 20) + "..." : data.nome_parc}
                          </Text>
                        </Td>
                        <Td padding=".3rem" textAlign="center" style={{ position: "relative", width: "160px" }}>
                          {data.nome_vendedor}
                        </Td>
                        <Td padding=".3rem" textAlign="center" style={{ position: "relative", width: "160px" }}>
                          R${" "}
                          {data.valor_nota.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                        <Td padding=".3rem" textAlign="center" style={{ width: "500px", posiotion: "relative" }}>
                          <Flex gap={3}>
                            <Input
                              type={"text"}
                              placeholder={"Nº Nota"}
                              size={"sm"}
                              onChange={(e) => setNumeroNota(e.target.value)}
                            />
                            <Button
                              colorScheme="blue"
                              size="sm"
                              w={"100px"}
                              onClick={() => updateNota(data.codigo_produto, data.numero_pedido)}
                            >
                              Confirmar
                            </Button>
                          </Flex>
                        </Td>
                      </Tr>
                    )
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="red" ref={cancelRef} ml={3} onClick={onClose}>
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
